import { HDate, months } from '@hebcal/core';
import { DataBroker } from './DataBroker';

function GetShiurIndex(gregDate) {
	const hDate = new HDate(gregDate);
	let CurrentDay = hDate.dd;
	let output = [];

	if (hDate.mm === months.CHESHVAN && CurrentDay === 30)
		CurrentDay = 29;

	if (hDate.mm === months.KISLEV && CurrentDay === 30)
		CurrentDay = 29;

	if (hDate.mm === months.ADAR_I && !hDate.isLeapYear())
	{
		output.push((months.ADAR_I) + "/" + CurrentDay);
		if (CurrentDay < 30)
			output.push((months.ADAR_II) + "/" + CurrentDay);
	}
	else
	{
		output.push((hDate.mm) + "/" + CurrentDay);
	}

	return output;
};

export async function GetHY(gregDate) {
	const indexShiurim = GetShiurIndex(gregDate);
	let data = [];
	let loaded = true;

	for (let i=0; i<indexShiurim.length; i++) {
		try {
			let tmp = await DataBroker.getDataText('hy/' + indexShiurim[i]);

			if (tmp === null)
				loaded = false;

			data.push(tmp);
		}
		catch (err) {
			loaded = false;
		}
	}

	return new Promise((myResolve, myReject) => {
		if (!loaded)
			myReject(DataBroker.getError());
		else {
			
			if (data.length > 1)
				myResolve(<div className='HayomYom' dangerouslySetInnerHTML={{ __html: data[0] + "<hr/>" + data[1] }} />);
			else
				myResolve(<div className='HayomYom' dangerouslySetInnerHTML={{ __html: data[0] }} />);
		}
	});
};